import React from 'react'
import { styled } from 'linaria/react'
import { cx } from 'linaria'
import { Check } from 'iconoir-react'
import { useIntl } from '@jetshop/intl'
import FilterDropdown from './FilterDropdown'
import {
   DIGIFI_FILTER_FIELD_NAMES,
   DIGIFI_SORT_VALUES,
} from '../../DigifiSearch/constants'

const SortPanel = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0.25rem 0;

   .sort-option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      padding: 0.6rem 1rem;
      background: none;
      border: none;
      text-align: left;
      font-weight: 600;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
         background-color: var(--color-vb-gray-2);
      }

      &.is-selected {
         color: var(--color-vb-blue);
         font-weight: 700;
      }
   }

   .sort-toggle-value {
      font-weight: 700;
   }
`

const SortDropdown = ({ filters, options = [], updateFilters }) => {
   const t = useIntl()
   const currentValue =
      filters?.find(f => f?.fieldName === DIGIFI_FILTER_FIELD_NAMES.SORT_BY)
         ?.value ?? DIGIFI_SORT_VALUES.RELEVANCE
   const currentOption =
      options.find(option => option.value === currentValue) ?? options[0]

   return (
      <FilterDropdown
         align="right"
         panelWidth="240px"
         label={
            <span>
               <span style={{ fontWeight: 500 }}>{t('Sort:')} </span>
               {currentOption?.label}
            </span>
         }
      >
         {({ close }) => (
            <SortPanel role="listbox">
               {options.map(option => {
                  const isSelected = option.value === currentOption?.value
                  return (
                     <li key={option.value || 'relevance'}>
                        <button
                           type="button"
                           role="option"
                           aria-selected={isSelected}
                           className={cx(
                              'sort-option',
                              isSelected && 'is-selected'
                           )}
                           onClick={() => {
                              updateFilters?.([
                                 {
                                    fieldName:
                                       DIGIFI_FILTER_FIELD_NAMES.SORT_BY,
                                    value: option.value,
                                 },
                              ])
                              close()
                           }}
                        >
                           {option.label}
                           {isSelected && (
                              <Check width={18} height={18} strokeWidth={2.5} />
                           )}
                        </button>
                     </li>
                  )
               })}
            </SortPanel>
         )}
      </FilterDropdown>
   )
}

export default SortDropdown
